import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export default function Statement() {
  return (
    <section
      id="ecosystem"
      className="relative bg-[#EFEDE7] text-[#15161A] pt-24 sm:pt-32 lg:pt-44 pb-0 overflow-hidden"
      data-testid="statement-section"
    >
      <div className="absolute top-8 left-6 sm:left-10 lg:left-12 t-mono text-[#15161A]/60 z-10">
        <div>§ 02 — Statement</div>
      </div>
      <div className="absolute top-8 right-6 sm:right-10 lg:right-12 t-mono text-[#15161A]/60 text-right z-10">
        Page 02 / 09
      </div>

      <div className="max-w-[1700px] mx-auto px-6 sm:px-10 lg:px-12 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-3 md:col-start-1 mb-10 md:mb-0">
          <div className="t-mono text-[#15161A]/55">— Why Credit Stone Digital</div>
          <div className="mt-3 t-body text-sm text-[#15161A]/70 max-w-[28ch] leading-relaxed">
            Credit Stone Digital — a private financial ecosystem for global
            investors. Track hedge fund portfolios, access investment fund
            opportunities, and connect to digital banking through one secure
            platform.
          </div>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15% 0px" }}
          transition={{ duration: 1.4, ease }}
          className="col-span-12 md:col-span-9 t-display text-[#15161A] text-[7vw] md:text-[5vw] lg:text-[4.2vw] leading-[0.95] tracking-[-0.045em]"
        >
          A private ecosystem
          <br />
          <span className="text-[#15161A]/45">— not just an app.</span>
          <br />
          Bank, invest, manage — quietly.
        </motion.h2>
      </div>

      {/* Card image — black background removed with alpha matting; hand bleeds off the right edge */}
      <div className="relative mt-12 sm:mt-20 lg:mt-24 overflow-hidden">
        <motion.img
          src="/csd-card.png"
          alt="Credit Stone Digital — premium client card"
          draggable="false"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 1.6, ease }}
          className="block ml-auto select-none"
          style={{
            width: "min(78vw, 920px)",
            height: "auto",
            marginRight: "-2vw",
            filter:
              "drop-shadow(0 30px 50px rgba(15, 22, 26, 0.10)) drop-shadow(0 10px 22px rgba(15, 22, 26, 0.06))",
          }}
        />

        <div className="absolute bottom-6 left-6 sm:left-10 lg:left-12 t-mono text-[#15161A]/45">
          Credit Stone Digital
        </div>
      </div>
    </section>
  );
}
